import './index.scss'
import React, { useRef } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { FreeMode } from 'swiper/modules'
import useSlider from '../../hooks/useSlider'

import morfLogo from '../../assets/logo.morf.png'
import stadtamthall from '../../assets/projectslider/slider.stadtamthall.klein.webp'
import wko from '../../assets/projectslider/slider.wko.klein.webp'
import prinoth from '../../assets/projekte/prinoth.webp'
import dibk from '../../assets/projectslider/slider.dibk.klein.webp'
import ak from '../../assets/projectslider/slider.aktirol.klein.webp'
import Senoplast from '../../assets/senoplast_color.webp'
import NHT from '../../assets/nht_color.webp'
import { Link } from 'gatsby'
import zmv from '../../assets/stubai.logo.black.webp'

const defaultTestimonials = [
  {
    text: 'Besonders hervorzuheben sind die <b>Flexibilität</b> und <b>Innovationskraft</b>, die das Unternehmen an den Tag legt. [...] <br> Darüber hinaus schätzen wir die <b>direkte Kommunikation</b> und die <b>lösungsorientierte Arbeitsweise</b>. Probleme werden nicht nur erkannt, sondern auch schnell und effizient gelöst.',
    image: morfLogo,
    company: 'Karf Morf AG',
    name: 'Geschäftsführer Mensur Mandra',
    link: '/projekte/morf',
  },
  {
    text: 'Ein Workshop mit derartigen Inhalten und Aufbereitung ist <b>auf dem Markt einzigartig</b>. Speziell für diese Art von Projekten braucht es zuverlässige Partner wie holzweg. Nicht nur wir als Team erfreuen uns am Ergebnis. Dieses findet vor allem Anklang bei den Schülerinnen und Schülern, die so spielerisch ihren Umgang mit dem Internet hinterfragen können. Wir sind auf die gemeinsame Errungenschaft mit holzweg sehr stolz und freuen uns auf die weitere Zusammenarbeit.',
    image: ak,
    company: 'Arbeiterkammer Tirol',
    name: 'Dr. Michael Obermeier, BEd.',
    link: '/projekte/arbeiterkammer',
  },
  {
    text: 'Prinoth ist seit mittlerweile <b>15 Jahren</b> Kunde der Holzweg GmbH und wir sind stets von der hervorragenden Zusammenarbeit begeistert. Dank Georg Bader und seinem kompetenten Team wurde aus einem einfachen <b>Dokumenten-Portal</b> ein leistungsstarkes, internationales Kommunikations-Portal, das heute nicht nur von unseren Kunden, sondern auch von Prinoth-Mitarbeitern aus <b>allen Geschäftsbereichen täglich genutzt</b> wird.',
    image: prinoth,
    company: 'Prinoth AG',
    name: 'Silke Stötzer',
    link: '/projekte/prinoth',
  },
  {
    text: 'Die Zusammenarbeit mit den verschiedenen Teammitgliedern der Firma holzweg war zu jedem Projektzeitpunkt sehr angenehm und konstruktiv. Der firmeninterne <b>Informationsfluss funktioniert ausgezeichnet</b>, auch wenn das Projekt dann von der Projektierungs- in die Umsetzungsphase kommt und sich die Ansprechpartner ändern.',
    image: stadtamthall,
    company: 'Stadtmarketing Hall in Tirol ',
    name: 'Mag. Anny Franzelin M.A.',
    link: '/projekte/stadtamthall',
  },
  {
    text: 'Für die Umsetzung eines Projektes mit so speziellen Inhalten und eines so großen Umfanges braucht es einen Partner, der diese <b>Anforderungen professionell und zuverlässig umsetzen</b> kann. Deshalb haben wir uns für die Firma holzweg entschieden. Die Zusammenarbeit mit der Firma holzweg war stets konstruktiv und sehr angenehm.',
    image: wko,
    company: 'Wirtschaftskammer Österreich / Tirol ',
    name: 'Roland Teißl',
    link: '/projekte/wirtschaftskammer',
  },
  {
    text: 'Sie haben uns von der ersten Stunde an begleitet. Mit <b>innovativen Ideen und kreativen Lösungsvorschlägen</b>, liefern uns die MitarbeiterInnen eine gute Entscheidungsbasis für die Umsetzung unserer Website. Die regelmässigen Workshops helfen uns verstehen, und erleichtern uns die Arbeit. Die Zusammenarbeit ist getragen von einer guten Gesprächsbasis und wir freuen uns, noch weiterhin von Ihrem Know-how profitieren zu können.',
    image: dibk,
    company: 'Diözese Innsbruck',
    name: 'Dr. Karin Bauer',
    link: '/projekte/dioezese',
  },
  {
    text: 'Als wir vor der großen Herausforderung standen, für 13 verschiedene Firmen einen Relaunch der Website zu gestalten, war uns bewusst, dass es für diese Aufgabe eine <b>Agentur mit viel Erfahrung</b> mit Multiportalsystemen, Mehrsprachigkeit und komplexen Aufgabensstellungen braucht.',
    image: Senoplast,
    company: 'Senoplast',
    name: 'Mag. Claudia Pichler',
    link: '/projekte/klepsch-group',
  },
  {
    text: 'Das Intranet dient als Kommunikations-, Wissens- und Informationsplattform des Unternehmens. Die einfache und übersichtliche Handhabung ermöglicht einen raschen Informationsfluss, die Implementierung von verschiedenen Systemen ermöglicht eine <b>effektive Kommunikation</b>. holzweg GmbH hat für alle <b>individuellen Ansprüche</b> eine Lösung parat, kompetente Ansprechpersonen machen die Zusammenarbeit einfach.',
    image: NHT,
    company: 'Neue Heimat Tirol',
    name: 'Christina Fally',
    link: '/projekte/nht',
  },
  {
    text: 'Zusammenarbeit mit Holzweg bei der Neugestaltung unserer Firmenwebsite war von Anfang an sehr angenehm und professionell. Bereits in der Konzeptionsphase hat uns das Team mit kreativen Ideen und einem klaren Blick für unsere Bedürfnisse überzeugt. Das Ergebnis spricht für sich: Die neue Website ist optisch modern, läuft stabil und schnell - genau so, wie wir es uns vorgestellt haben. Besonders positiv ist uns die unkomplizierte und zuverlässige Kommunikation aufgefallen. Änderungswünsche wurden stets rasch umgesetzt, und auch die technische Umsetzung, inklusive umfangreicher Datenübernahme, hat einwandfrei funktioniert.',
    image: zmv,
    company: 'Stubai ZMV',
    name: 'Manuel Mayr',
    link: '/projekte/stubai',
  },
]

const Testimonials = ({ testimonials = defaultTestimonials }) => {
  const swiperRef = useRef(null)
  const { onInit, handleDrag } = useSlider(swiperRef)

  const options = {
    slidesPerView: 2.5,
    freeMode: {
      enabled: true,
    },
    centeredSlides: false,
    spaceBetween: 15,
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 1.2,
      },
      1224: {
        slidesPerView: 2.5,
      },
    },
  }

  return (
    <div className="testimonials">
      <div className="container">
        <h2 className="testimonials__title">Das sagen unsere Kunden</h2>
        <p className="testimonials__subheading">
          Überzeugen Sie sich selbst, und schauen Sie bei unseren bisherigen
          Projekten vorbei
        </p>
        <div className="testimonials__container">
          <Swiper
            {...options}
            onBeforeInit={onInit}
            onSlideChange={handleDrag}
            modules={[FreeMode]}
          >
            {testimonials.map((testimonial, index) => (
              <SwiperSlide key={index} virtualIndex={index}>
                <div className="testimonials__item">
                  <div className="testimonials__item-top">
                    <span>"</span>
                  </div>
                  <p
                    className="testimonials__item-content"
                    dangerouslySetInnerHTML={{ __html: testimonial.text }}
                  />
                  <div className="testimonials__item-bottom">
                    <Link to={testimonial.link}>
                      <div className="testimonials__item-bottom-img">
                        <img
                          src={testimonial.image}
                          alt={testimonial.company}
                          loading="lazy"
                        />
                      </div>
                      <div className="testimonials__item-bottom-name">
                        <div className="testimonials__item-bottom-name-company">
                          {testimonial.company}
                        </div>
                        <div className="testimonials__item-bottom-name-name">
                          {testimonial.name}
                        </div>
                      </div>
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  )
}

export default Testimonials
